import { getApiUrl } from "../utils/get-api-url";

export const getPaymentPlans = async (quoteId: string) => {
  const apiUrl = getApiUrl("pxcentral");
  const fullUrl = `${apiUrl}/policies/${quoteId}/paymentplans`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include"
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(text || statusText);
  const json = xml2json(text);
  return Promise.resolve(json);
};

const xml2json = xml => {
  const jsonResult = [];
  const re = /<PaymentPlan (.+?)\/>/gi;
  let myArray;
  while ((myArray = re.exec(xml)) !== null) {
    const attrsStr = myArray[1] && myArray[1].trim();
    if (!attrsStr) return;
    jsonResult.push(
      attrsStr.split(" ").reduce((acc, attr) => {
        const matches = attr.match(/([a-z]+)="(.*?)"/i);
        return {
          ...acc,
          [matches[1]]: matches[2]
        };
      }, {})
    );
  }

  return jsonResult;
};
